import * as types from './actionTypes';
import api from '../../../api/';

export function getContributorProfileDetails(id) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const contributorDetails = await api.getContributorContribution(id);
      const contributorData = await api.getContributorProfile(id);
      const constributorTops = await api.getContributorTop(id);
      const following = await api.getFollowing();
      let isFollowing = false;
      let followingArray = following.content ? following.content : [];
      for (let i = 0; i < followingArray.length; i++) {
        if (id.toString() === followingArray[i].id.toString()) {
          isFollowing = true;
          break;
        }
      }
      dispatch({
        type: types.LOAD_DATA,
        contributorDetails,
        contributorData,
        constributorTops,
        isFollowing
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function follow(id) {
  return async (dispatch, getState) => {
    dispatch({
      type: types.FOLLOW_LOAD,
    });
    try {
      await api.follow(id);
      dispatch({
        type: types.FOLLOW
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function unFollow(id) {
  return async (dispatch, getState) => {
    dispatch({
      type: types.FOLLOW_LOAD,
    });
    try {
      await api.unFollow(id);
      dispatch({
        type: types.UNFOLLOW
      });
    } catch (error) {
      console.log(error);
    }
  };
}
